import React from "react";
import { useImmerReducer } from "use-immer";
import { Role } from "./models";

const initialState: RolesStore = {
  isInitialized: false,
  roles: [],
};

export interface RolesStore {
  isInitialized: boolean;
  roles: Role[];
}

interface AuthorizationContext {
  roleStore: RolesStore;
  dispatch: (action: TAction) => RolesStore;
}

const Context = React.createContext<AuthorizationContext>({
  roleStore: initialState,
  dispatch: () => initialState,
});

type TAction = { type: "set-roles"; payload: Role[] };

// This state is protected by immer so mutate-away!!
function reducer(state: RolesStore, action: TAction) {
  switch (action.type) {
    case "set-roles":
      state.roles = action.payload;
      state.isInitialized = true;
      break;
  }
  return state;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function RolesProvider(props: any) {
  const [roleStore, dispatch] = useImmerReducer(reducer, initialState);
  const value = React.useMemo(
    () => ({ roleStore, dispatch }),
    // eslint-disable-next-line
    [roleStore],
  );
  return (
    <Context.Provider
      value={value}
      {...props}
    />
  );
}

export { RolesProvider, Context as RolesContext };
